import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN?.trim()
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || 'development'
const RELEASE = import.meta.env.VITE_RELEASE_SHA || 'dev'

let initialized = false

export function initSentry() {
  if (initialized || !SENTRY_DSN) {
    return
  }

  const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0)
  const replaySessionSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE || 0)
  const replayOnErrorSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE || 1.0)

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: RELEASE,
    tracesSampleRate,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    replaysSessionSampleRate: replaySessionSampleRate,
    replaysOnErrorSampleRate: replayOnErrorSampleRate,
  })

  initialized = true
}

export function triggerSentrySmokeTest() {
  if (!SENTRY_DSN) {
    return null
  }

  return Sentry.captureMessage('Frontend Sentry smoke test from Fukodrom', {
    level: 'error',
    tags: {
      area: 'frontend',
      smoke_test: 'true',
    },
  })
}
